// Cliente da API. Sessão vai no cookie HttpOnly (o JS não vê o token).
export class ErroApi extends Error {
  constructor(public status: number, public codigo: string, mensagem: string) {
    super(mensagem);
  }
}

export async function api<T>(caminho: string, opcoes: { metodo?: string; corpo?: unknown } = {}): Promise<T> {
  let r: Response;
  try {
    r = await fetch(`/api${caminho}`, {
      method: opcoes.metodo ?? 'GET',
      credentials: 'same-origin',
      headers: {
        'x-vivium-cliente': 'painel',
        ...(opcoes.corpo !== undefined ? { 'content-type': 'application/json' } : {}),
      },
      body: opcoes.corpo !== undefined ? JSON.stringify(opcoes.corpo) : null,
    });
  } catch {
    throw new ErroApi(0, 'sem_conexao', 'Sem conexão com o servidor. Verifique a internet.');
  }
  if (r.status === 204) return undefined as T;
  const dados = await r.json().catch(() => ({}));
  if (!r.ok) throw new ErroApi(r.status, dados.erro ?? 'erro', dados.mensagem ?? `Erro ${r.status}`);
  return dados as T;
}

/** Envia um arquivo cru (ex.: PDF do contrato) — a API lê o corpo binário pelo content-type. */
export async function enviarArquivo<T>(caminho: string, arquivo: Blob, tipo: string): Promise<{ status: number; dados: T }> {
  let r: Response;
  try {
    r = await fetch(`/api${caminho}`, { method: 'POST', credentials: 'same-origin', headers: { 'x-vivium-cliente': 'painel', 'content-type': tipo }, body: arquivo });
  } catch {
    throw new ErroApi(0, 'sem_conexao', 'Sem conexão com o servidor. Verifique a internet.');
  }
  const dados = await r.json().catch(() => ({}));
  if (!r.ok) throw new ErroApi(r.status, dados.erro ?? 'erro', dados.mensagem ?? (r.status === 413 ? 'Arquivo grande demais.' : `Erro ${r.status}`));
  return { status: r.status, dados: dados as T };
}

/** Baixa um arquivo autenticado (cookie) e devolve uma URL local (blob:) para mostrar ou abrir. */
export async function urlDeArquivo(caminho: string): Promise<string> {
  const r = await fetch(`/api${caminho}`, { credentials: 'same-origin', headers: { 'x-vivium-cliente': 'painel' } });
  if (!r.ok) { const d = await r.json().catch(() => ({})); throw new ErroApi(r.status, d.erro ?? 'erro', d.mensagem ?? `Erro ${r.status}`); }
  return URL.createObjectURL(await r.blob());
}

export interface Usuario {
  id?: string;
  usuarioId?: string;
  nome: string;
  email: string;
  papel: string;
  permissoes: string[];   // efetivas: papel + ajustes do usuário
  trocarSenha?: boolean;  // senha provisória: só pode trocar a senha
}

export interface Resumo {
  gerado_em: string;
  clientes_ativos: number;
  locais: number;
  ativos: number;
  contratos_ativos: number;
  os_abertas: number;
  os_sla_vencido: number;
  chamados_novos: number;
  tecnicos: number;
}
